const colorPool = ['#781fe0', '#02591a', '#731990', '#f6805b', '#284951', '#641240', '#d6bf4f'];
const idColorMap = new Map();
const fallbackColor = '#13ea6c';
export const getPresetColor = (id) => {
    if (typeof idColorMap.get(id) === 'undefined') {
        const colorToMap = colorPool.shift() ?? fallbackColor;
        idColorMap.set(id, colorToMap);
    }
    return idColorMap.get(id);
};
//# sourceMappingURL=get-preset-color.js.map